import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_setEnterpriseType($coursesData: [CourseData]) {
    Course_setEnterpriseType(coursesData: $coursesData) {
      id
    }
  }
`;

const courseSetEnterpriseType = async coursesData =>
  graphql(mutation, { coursesData }).then(data => data.Course_setEnterpriseType);

export default courseSetEnterpriseType;
